import React from "react";
import CheckboxChecked from "assets/icons/CheckboxChecked.svg";
import CheckboxUnchecked from "assets/icons/CheckboxUnchecked.svg";

const CheckBox = ({ checked, ...props }) => (
  <img {...props} src={checked ? CheckboxChecked : CheckboxUnchecked} alt="" />
);

export default CheckBox;
